// extracted by mini-css-extract-plugin
export default {"sessionCard":"sessioninfocard_sessionCard__cg80f","sessionInfo":"sessioninfocard_sessionInfo__dmiyF"};